import { ErrorObjProps } from './errorTypes';

export const emptyErrorObj: ErrorObjProps = {
  generalError: '',
  checkoutError: {},
  discountsError: {},
  eligibilityError: {},
  consentDataFetchError: {},
};
